import { render } from "./SliderMain1-1.vue?vue&type=template&id=01dc16c8&scoped=true"
import script from "./SliderMain1-1.vue?vue&type=script&lang=js"
export * from "./SliderMain1-1.vue?vue&type=script&lang=js"

import "./SliderMain1-1.vue?vue&type=style&index=0&id=01dc16c8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01dc16c8"]])

export default __exports__